module.exports = __webpack_public_path__ + "static/media/Ashmayu_B.0713e700.png";